const puzzle = {
  id: "DWAFgWYPsJeU8qtoSqkJ",
  name: "Celebratory Chemistry",
  rebuses: [
    {
      id: "8bea0ea9-f085-439f-bd66-d5d3afe90876",
      style: {},
      clues: [
        {
          helperText:
            "First name of the actress playing Lagertha in TV show Vikings.",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "Katheryn",
                id: "202d891b-4d1f-492b-aa27-cdb98dac7a46",
              },
            ],
            solvedText: "Katheryn",
            type: "text",
          },
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          id: "531616ab-79cd-4d2a-961b-4c56fb563227",
          clueGroup: 0,
          clueValues: [
            {
              value: "uiq3Te5Y.png",
              subtext: "Vikings",
              id: "cdb98372-821b-4270-b69e-1c4bb3b66f90",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "image",
            },
          ],
          subtext: "",
        },
        {
          subtext: "",
          id: "aaff4c0d-8ccd-4796-a143-b9d765c6a3a9",
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            "First name of the character played by Keira Knightley in Pirates of the Carribean movies.",
          clueValues: [
            {
              subtext: "Pirates of the Carribean",
              value: "lHxL1dyK.png",
              type: "image",
              id: "f33ac328-0cec-4553-a4e3-a5914cf0eaaf",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            possibleSolutions: [
              {
                id: "e70583c1-b4fc-454a-b7e9-81b925c56277",
                value: "Elizabeth",
              },
            ],
            solvedText: "Elizabeth",
            type: "text",
          },
          clueGroup: 0,
          dependsOn: [],
        },
        {
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              type: "image",
              value: "CUs8L2Of.png",
              id: "4f9f9d56-8b2e-4e62-9ccd-892f20f5110d",
              subtext: "How to Lose a Guy in 10 Days",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          subtext: "",
          dependsOn: [],
          id: "b7868b22-052a-4daf-a73c-d33624208fc6",
          helperText:
            "Last name of the actress playing Andie Anderson in the movie How to Lose a Guy in 10 Days..",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "Hudson",
                id: "41b639ad-7311-43a3-95f7-d52c3dcd8b24",
              },
            ],
            type: "text",
            solvedText: "Hudson",
          },
        },
      ],
      solutionInfo: {
        solvedText: "Katy Perry",
        type: "text",
        possibleSolutions: [
          {
            id: "49a9b2d9-9259-44aa-b15d-5c006fb52783",
            value: "Katy Perry",
          },
        ],
      },
    },
    {
      solutionInfo: {
        possibleSolutions: [
          {
            id: "1137f53e-cd6c-4a8c-8174-23565d9e6edd",
            value: {
              second: "",
              day: "4",
              year: "",
              minute: "",
              month: "July",
              hour: "",
              place: "",
            },
          },
        ],
        type: "date",
        solvedText: "4th of July",
      },
      id: "2f2e7d3a-1e03-44ca-9022-a4b65042ddbf",
      clues: [
        {
          solutionInfo: {
            solvedText: "4th of July",
            possibleSolutions: [],
            type: "date",
          },
          helperText:
            "Same thing happened to all three of these US presidents on the same date.",
          clueValues: [
            {
              id: "551980d6-b4ea-4b77-a4dc-9ffa86f787f3",
              value: "9Xzo57QH.png",
              style: {
                width: "calc(70% - 10px)",
              },
              type: "image",
              subtext: "",
            },
          ],
          dependsOn: [],
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "4d27e5a1-14ee-471f-aa3b-b021cd50dab6",
          clueGroup: 0,
        },
      ],
      style: {},
    },
    {
      clues: [
        {
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              id: "a9f43e61-6509-4ce3-b4d9-a2b3becfc9f3",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
              },
              value: "RL7Vmm5S.png",
              subtext: "All roads",
            },
          ],
          id: "ee60a4fb-8fe7-4fcf-b87e-c3fb11512427",
          dependsOn: [],
          clueGroup: 1,
          solutionInfo: {
            solvedText: "Rome",
            possibleSolutions: [
              {
                id: "b834484a-fbb1-447c-9b29-2a219d388c4c",
                value: "Rome",
              },
            ],
            type: "text",
          },
          subtext: "",
          helperText: "Where do all roads lead, according to old saying?",
        },
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
                fontSize: "30px",
              },
              subtext: "",
              type: "text",
              id: "9e24b05e-b7fb-4ec2-b456-fb449523b1de",
              value: "Tall when it's young, short when it's old",
            },
          ],
          dependsOn: [],
          helperText: "It's made of wax.",
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 2,
          solutionInfo: {
            solvedText: "Candle",
            type: "text",
            possibleSolutions: [
              {
                value: "Candle",
                id: "8ceef84b-681b-4587-89a3-da96d062fa22",
              },
            ],
          },
          id: "e947193e-9d66-4a00-8efa-5ff70ea93f9b",
        },
      ],
      solutionInfo: {
        possibleSolutions: [],
        type: "text",
        solvedText: "Roman Candle",
      },
      style: {},
      id: "81d77483-b540-43b8-8d62-c883c2072049",
    },
    {
      solutionInfo: {
        type: "text",
        solvedText: "Firework",
        possibleSolutions: [
          {
            id: "e94435fd-8195-4743-8d26-7ecb72b8850e",
            value: "Firework",
          },
          {
            value: "Fireworks",
            id: "1244f0dc-a5ce-41cd-a09b-991940ca7e60",
          },
        ],
      },
      clues: [
        {
          clueValues: [
            {
              value: "Katy Perry",
              type: "text",
              id: "4cacaf3b-e09d-4129-820f-7853228b5114",
              subtext: "Song title",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          subtext: "",
          helperText: "It's a song by Katy Perry.",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          id: "7526d637-0891-45eb-b6a7-7750ae4f0f6c",
          clueGroup: 0,
        },
        {
          id: "313bab3e-480c-40b3-8283-94aafde328f0",
          dependsOn: [],
          helperText:
            "It's a tradition happening mostly at night on 4th of July.",
          clueValues: [
            {
              type: "text",
              subtext: "Tradition",
              value: "4th of July",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "3ed5edad-6cad-4577-a424-00f5b719706d",
            },
          ],
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
        },
        {
          id: "cfad9092-b1a6-4d71-9791-09bb8df8cde5",
          clueValues: [
            {
              id: "9094d673-ea6c-4570-9a5a-50cf32ecee51",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Type",
              type: "text",
              value: "Roman Candle",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          helperText: "It's a type of the thing we're looking for.",
        },
      ],
      style: {},
      id: "7fc1a5de-7ba1-4446-8f3b-a45818a61773",
    },
  ],
};

export default puzzle;
